import { render, staticRenderFns } from "./FbRandoms.vue?vue&type=template&id=236d5789"
import script from "./FbRandoms.vue?vue&type=script&lang=js"
export * from "./FbRandoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports